import { useState, useEffect } from 'react';

function getWindowDimensions() {
    const hasWindow = typeof window !== 'undefined';
    return {
      width: hasWindow ? window.innerWidth : null,
      height: hasWindow ? window.innerHeight : null,
      screenSize: window.innerWidth < 576 ? "xs" : window.innerWidth < 768 ? "sm" : window.innerWidth < 992 ? "md" : window.innerWidth < 1200 ? "lg" : null
    };
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
